import { httpClient } from "@services/api/httpClient";


export async function getOfferAssesmentQuestions(offerId: number | string) {
  const response = await httpClient.get("/offer-assesment/questions", {
    params: { offerId }
  });
  return response.data;
}